import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { Filter, Main } from 'Containers';
import { ReportGeneration } from 'Common/ObjectHelper';
import { ReportFieldEnum } from 'Common/FieldEnum';
import { TEACHER_ROLLS_FORM_NAME } from 'Common/FormEnum';

import TeacherRollsForm from './components/TeacherRollsForm';
import {
  getTeachersAction,
  getTeachersReportAction,
  clearReportDataAction,
} from './state/actions';

class TeacherRollsContainer extends Component {
  siteChange = (site) => {
    this.props.getTeachersAction(site);
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.recordFetching && nextProps.report) {
      if (nextProps.report.length !== 0) {
        const { report } = nextProps;
        ReportGeneration(report, 'TeachersRollReport');
        this.props.clearReportDataAction();
      }
    }
  }

  formSubmit = (values) => {
    const model = {
      SiteId: values[ReportFieldEnum.Site],
      Teacher: values[ReportFieldEnum.Teacher],
      GradeId: values[ReportFieldEnum.Grade],
      Balance: values[ReportFieldEnum.Balance],
      BarCodes: values[ReportFieldEnum.BarCodes],
      Status: values[ReportFieldEnum.Status],
      Allergies: values[ReportFieldEnum.Allergen],
      StudentOrServingNumber: values[ReportFieldEnum.UseServingNumber],
      IncludeNonLeaStudents: values[ReportFieldEnum.IncludeNonLeaStudents],
    };

    this.props.getTeachersReportAction(model);
  };

  getMainProps = () => {
    const { recordFetching, fieldLoading } = this.props;

    return {
      toolbox: {
        formName: TEACHER_ROLLS_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: recordFetching,
          disabled: fieldLoading || recordFetching,
        },
        shown: true,
      },
    };
  };

  render() {
    const { teachersInfo, recordFetching, fieldLoading } = this.props;

    return (
      <Fragment>
        <Filter title={'Teacher Rolls'} />
        <Main {...this.getMainProps()}>
          <TeacherRollsForm
            onSubmit={this.formSubmit}
            siteChange={this.siteChange}
            initialValues={{
              [ReportFieldEnum.BarCodes]: false,
              [ReportFieldEnum.Balance]: false,
              [ReportFieldEnum.Status]: false,
              [ReportFieldEnum.Allergen]: false,
              [ReportFieldEnum.UseServingNumber]: true,
              [ReportFieldEnum.IncludeNonLeaStudents]: true,
            }}
            teachers={
              teachersInfo && teachersInfo.Data ? teachersInfo.Data : []
            }
            disabled={fieldLoading || recordFetching}
            fetching={recordFetching}
            loading={fieldLoading}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ TeacherRollsState }) => {
  return {
    teachersInfo: TeacherRollsState.teachersInfo,
    recordFetching: TeacherRollsState.reportLoading,
    report: TeacherRollsState.reports,
    fieldLoading: TeacherRollsState.fieldLoading,
  };
};

export const TeacherRolls = withRouter(
  connect(mapStateToProps, {
    getTeachersAction,
    getTeachersReportAction,
    clearReportDataAction,
  })(TeacherRollsContainer)
);



// WEBPACK FOOTER //
// ./src/pages/teacherrolls/TeacherRolls.js